import { useCallback, useEffect, useRef, useState } from 'react';

const useHugoPanelAnimation = ({ transitionMs }) => {
    const [isOpen, setIsOpen] = useState(false);
    const [isPanelMounted, setIsPanelMounted] = useState(false);
    const [isPanelVisible, setIsPanelVisible] = useState(false);

    const panelOpenFrameRef = useRef(null);
    const panelCloseTimerRef = useRef(null);

    const clearPanelAnimationTimers = useCallback(() => {
        if (panelOpenFrameRef.current) {
            cancelAnimationFrame(panelOpenFrameRef.current);
            panelOpenFrameRef.current = null;
        }

        if (panelCloseTimerRef.current) {
            clearTimeout(panelCloseTimerRef.current);
            panelCloseTimerRef.current = null;
        }
    }, []);

    const openPanel = useCallback(() => {
        clearPanelAnimationTimers();
        setIsPanelMounted(true);
        setIsOpen(true);

        panelOpenFrameRef.current = requestAnimationFrame(() => {
            panelOpenFrameRef.current = requestAnimationFrame(() => {
                setIsPanelVisible(true);
            });
        });
    }, [clearPanelAnimationTimers]);

    const closePanel = useCallback(() => {
        clearPanelAnimationTimers();
        setIsPanelVisible(false);
        setIsOpen(false);

        panelCloseTimerRef.current = setTimeout(() => {
            setIsPanelMounted(false);
        }, transitionMs);
    }, [clearPanelAnimationTimers, transitionMs]);

    useEffect(() => {
        return clearPanelAnimationTimers;
    }, [clearPanelAnimationTimers]);

    return {
        closePanel,
        isOpen,
        isPanelMounted,
        isPanelVisible,
        openPanel,
    };
};

export default useHugoPanelAnimation;
